// hooks/useUserData.ts
'use client';

import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';

interface UserData {
    tipoUtenteListino?: string;
    // aggiungi altre proprietà dell'utente se necessario
}

export const useUserData = () => {
    const [userData, setUserData] = useState<UserData | null>(null);
    const [tipoUtenteListino, setTipoUtenteListino] = useState<string>('PRI');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const getUserDataFromCookies = () => {
            try {
                const userCookie = Cookies.get('userData');
                if (userCookie) {
                    const parsedUserData: UserData = JSON.parse(userCookie);
                    setUserData(parsedUserData);
                    setTipoUtenteListino(parsedUserData?.tipoUtenteListino || 'PRI');
                }
            } catch (error) {
                console.error('Errore nel parsing dei cookie userData:', error);
                setTipoUtenteListino('PRI');
            } finally {
                setIsLoading(false);
            }
        };

        getUserDataFromCookies();
    }, []);

    const updateUserData = (newUserData: UserData) => {
        try {
            Cookies.set('userData', JSON.stringify(newUserData), { expires: 7 });
            setUserData(newUserData);
            setTipoUtenteListino(newUserData?.tipoUtenteListino || 'PRI');
        } catch (error) {
            console.error('Errore nel salvataggio dei cookie userData:', error);
        }
    };

    return {
        userData,
        tipoUtenteListino,
        isLoading,
        updateUserData
    };
};
